export default "__VITE_ASSET__10qWFxef__"